import * as Yup from "yup";

const NATIONALITY = {
  DOMESTIC: "domestic",
  FOREIGNER: "foreigner",
};

export const initialValues = {

  institute: null,
  educationDegreeId: null,
  graduatedFrom: null,
  faculty: null,
  majorSubject: null,
  gpax: null,
  startDate: null,
  endDate: null
};

const EmployeeEducationSchema = Yup.object().shape({
  institute: Yup.string().required("Please enter institute."),
  educationDegreeId: Yup.string().required("Please select education degree."),
  graduatedFrom: Yup.string().required("Please enter Graduated From."),
  // startDate: Yup.string().required("Please enter Year From."),
  // endDate: Yup.string().required("Please enter Year To").test('endDate', 'Year To must be later than Year From', function (value) {
  //   const { startDate } = this.parent;
  //   return value >= startDate;
  // }),

});

export default EmployeeEducationSchema;
